<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-body">
        <el-form
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <iframe
              :src="mData.dataDefault.links"
              width="100%"
              height="800px"
              frameborder="0"
              style="z-index: 10"
            ></iframe>
          </b-row>
          <el-form-item class="text-center mt-3">
            <!-- <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>-->

            <el-button @click="fn_go()" type="info" plain>{{
              aLang.c_back
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";
import AccountApi from "../../../moduleApi/AccountApi";
import SurveyApi from "../../../moduleApi/SurveyApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "update",
        moduleName: "DiemDenAnToan",
        dataDefault: {
          roles: DataService.rolesInForm,
          links: "",
          iframe: {
            src: "",
            style: null,
            wrapperStyle: null,
          },
        },
        dialog: {},
      },
    };
  },
  methods: {
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await DiemDenAnToanApi.findById(id);

      let objJsonB64 = "";
      let prefillSurvey;
      if (res.result.du_lieu_khai_bao) {
        objJsonB64 = Buffer.from(
          JSON.stringify(res.result.du_lieu_khai_bao)
        ).toString("base64");
        prefillSurvey = await SurveyApi.getPrefillId({ data: objJsonB64 });
      }
      let pathLocation =
        location.protocol + "//" + location.host + "/admin/DiemDenAnToan/success";

      let params = {
        prefillData: prefillSurvey.result,
        appCode: "Tourism",
        callbackUrl: pathLocation,
        env: window.MyConfig.surveyDailyEnv
      };

      let resCode = await AccountApi.generateHashCode(params);
      // console.log(resCode.result);

      this.mData.dataDefault.links +=
        window.MyConfig.surveyEnv +
        "prefillId=" +
        prefillSurvey.result +
        "&hashCode=" +
        resCode.result.toString().toLowerCase() +
        "&appCode=Tourism" +        
        "&env=" + window.MyConfig.surveyDailyEnv + 
        "&callbackUrl=" +
        encodeURIComponent(pathLocation);
      // debugger;
    },
    async fn_initDataDefault() {},
  },
  created: function () {
    this.fn_initDataDefault();

    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }

    this.fn_getDataById(this.$router.currentRoute.params.id);
  },
  mounted: function () {},
};
</script>
<style scoped>
.card {
  position: relative;
}

.card::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  height: 70%;
  background-image: url("~/img/safe-travel.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  opacity: 0.1;
  transform: translate(-50%, -50%);
  z-index: 1;
}
</style>
